<div class="modal-content">
  <div class="modal-header">
    <h5 style="padding: 0.5rem 1rem;" class="modal-title heading-6" id="modal-basic-title">
      {{ 'common.policies.policies-of' | translate }} {{ company?.name }}
    </h5>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="closeModal()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

  <div class="modal-body">
    <div *ngIf="policies?.length; else noPolicies">
      <div class="policy-list">
        <div *ngFor="let policy of policies" class="policy-item d-flex justify-content-between align-items-center">
          <i class="fa fa-info-circle color-info" matTooltip="{{ getPolicyTooltip(policy) }}" matTooltipClass="policy-tooltip"></i>&nbsp;&nbsp;
          <span class="policy-name text-truncate" title="{{ policy.name }}">{{ policy.name }}</span>

          <div class="policy-actions">
              <button tabindex="-1" mat-button color="success" class="policy-action-btn" (click)="editPolicy(policy)">
                <p style="margin: 0;">{{ "common.edit" | translate }}</p>
              </button>
              <button tabindex="-1" mat-button color="warn" class="policy-action-btn" (click)="deletePolicy(policy)" 
                [disabled]="policy.name === 'Default'">
                <p style="margin: 0;">{{ "common.delete" | translate }}</p>
              </button>
          </div> 
        </div>
      </div>
    </div>

    <ng-template #noPolicies>
      <p>{{ "common.policies.no-policies-available" | translate }}</p>
    </ng-template>
  </div>

  <div class="modal-footer custom-footer">
    <button style="color: white !important;" class="btn btn-primary" (click)="createPolicy()">{{ "common.policies.new-policy" | translate }}</button>
  </div>
</div>